import { render, staticRenderFns } from "./logo.vue?vue&type=template&id=4c3e97b8&scoped=true"
import script from "./logo.vue?vue&type=script&setup=true&lang=js"
export * from "./logo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./logo.vue?vue&type=style&index=0&id=4c3e97b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3e97b8",
  null
  
)

export default component.exports